export default __webpack_public_path__ + "static/media/17.b0420538.svg";